export default __webpack_public_path__ + "static/spark-video-bg-2138f6d26359b6de649a5d9658ec994f.webp";